import classnames from 'classnames'
import styles from 'dashboard-subscriptions/components/styles.module.scss'
import Button from '@components/Button'
import { formatWithHoursMinutes } from 'shared/time-utilites'
import CircleLoader from '@components/CircleLoader'

const SubscriptionModalHeader = ({ subscription, goPay, isActiveSubscription, showPayBtn }) => {
    const startDate = formatWithHoursMinutes(subscription.effectiveDate)

    return (
        <div className={classnames('d-md-flex', styles.modalHeader)}>
            <div>
                <span className={styles.line}>
                    <span className={styles.lineDescription}>
                        <T>dashboard.label.subscription</T>
                    </span>
                    <span className={styles.subscriptionId}>: {subscription.id}</span>
                </span>
                <span className={styles.line}>
                    <T>dashboard.label.start.date</T>: {startDate}
                </span>
                <span className={styles.line}>
                    <T>dashboard.label.location</T>: {subscription.locationSumary?.name}
                </span>
            </div>
            <div className="flex-column ml-auto">
                <span className={styles.balanceDescription}>Due balance</span>
                <div className="row no-gutters align-items-center mt-2">
                    {subscription.balance === undefined ? (
                        <CircleLoader size="small" className="mt-2" />
                    ) : (
                        <span className={styles.balance}>${subscription.balance || '0.00'}</span>
                    )}
                    {showPayBtn && isActiveSubscription && (
                        <Button size="small" className={styles.payBtn} onClick={goPay}>
                            <T>dashboard.subscriptions.pay</T>
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SubscriptionModalHeader
